import React from 'react';
import { Navigate } from 'react-router-dom';
import MainLayout from './layouts/Mainlayout';
import SimpleLayout from './layouts/SimpleLayout';
import Login from './views/Login';
import AsyncComponent from './components/AsyncComponent';
import CommonIframePage from './views/CommonIframePage';
import OrderManagement from './views/OrderManagement';
import InsuranceManage from './views/InsuranceManage';
import InsuranceManageAdd from './views/InsuranceManage/Add';
import InsuranceManageEdit from './views/InsuranceManage/Edit';
import CostAllocationManage from './views/CostAllocationManage';

const GridManage = AsyncComponent(
  () => import(/* webpackChunkName: "GridManage" */ './views/GridManage')
);
const GridManageEdit = AsyncComponent(
  () =>
    import(/* webpackChunkName: "GridManageEdit" */ './views/GridManage/Edit')
);
const HardwareModel = AsyncComponent(
  () => import(/* webpackChunkName: "HardwareModel" */ './views/HardwareModel')
);
const HardwareModelEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "HardwareModelEdit" */ './views/HardwareModel/edit'
    )
);
const SensorSolution = AsyncComponent(
  () =>
    import(/* webpackChunkName: "SensorSolution" */ './views/SensorSolution')
);
const SensorSolutionEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "SensorSolutionEdit" */ './views/SensorSolution/Edit'
    )
);
const HardwareType = AsyncComponent(
  () => import(/* webpackChunkName: "HardwareType" */ './views/HardwareType')
);
const HardwareTypeEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "HardwareTypeEdit" */ './views/HardwareType/Edit'
    )
);
const VehicleType = AsyncComponent(
  () => import(/* webpackChunkName: "VehicleType" */ './views/VehicleType')
);
const VehicleTypeEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleTypeEdit" */ './views/VehicleType/Edit'
    )
);
const DeviceInfo = AsyncComponent(
  () => import(/* webpackChunkName: "DeviceInfo" */ './views/DeviceInfo')
);
const DeviceInfoEdit = AsyncComponent(
  () =>
    import(/* webpackChunkName: "DeviceInfoEdit" */ './views/DeviceInfo/Edit')
);
const FactoryManage = AsyncComponent(
  () => import(/* webpackChunkName: "FactoryManage" */ './views/FactoryManage')
);
const FactoryManageEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "FactoryManageEdit" */ './views/FactoryManage/Edit'
    )
);
const RepairOrderManagement = AsyncComponent(
  () => import(/* webpackChunkName: "Three" */ './views/RepairOrderManagement')
);
const StationManagement = AsyncComponent(
  () => import(/* webpackChunkName: "Three" */ './views/StationManagement')
);
const AddStation = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "AddStation" */ './views/StationManagement/components/AddStation'
    )
);
const StationDetail = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "StationDetail" */ './views/StationManagement/components/StationDetail'
    )
);
const VehicleInstruction = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleInstruction" */ './views/VehicleInstruction'
    )
);
const VehicleInstructionEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleInstructionEdit" */ './views/VehicleInstruction/Edit'
    )
);
const AbnormalStart = AsyncComponent(
  () => import(/* webpackChunkName: "AbnormalStart" */ './views/AbnormalStart')
);
const AbnormalStartEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "AbnormalStartEdit" */ './views/AbnormalStart/Edit'
    )
);
const HardwareSerial = AsyncComponent(
  () =>
    import(/* webpackChunkName: "HardwareSerial" */ './views/HardwareSerial')
);
const AppOperation = AsyncComponent(
  () => import(/* webpackChunkName: "AppOperation" */ './views/AppOperation')
);
const MrManage = AsyncComponent(
  () => import(/* webpackChunkName: "MrManage" */ './views/MrManage')
);
const MrEdit = AsyncComponent(
  () => import(/* webpackChunkName: "MrEdit" */ './views/MrManage/Edit')
);

const IssueCategoryManage = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "IssueCategoryManage" */ './views/IssueCategoryManage'
    )
);
const IssueCategoryEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "IssueCategoryEdit" */ './views/IssueCategoryManage/Edit'
    )
);

const IssueLabelManage = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "IssueLabelManage" */ './views/IssueLabelManage'
    )
);
const IssueLabelEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "IssueLabelEdit" */ './views/IssueLabelManage/Edit'
    )
);

const TestingManage = AsyncComponent(
  () => import(/* webpackChunkName: "TestingManage" */ './views/TestingManage')
);
const TestingEdit = AsyncComponent(
  () =>
    import(/* webpackChunkName: "TestingEdit" */ './views/TestingManage/Edit')
);
const ErrorCodeConf = AsyncComponent(
  () => import(/* webpackChunkName: "ErrorCodeConf" */ './views/ErrorCodeConf')
);
const ErrorCodeConfEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "ErrorCodeConfEdit" */ './views/ErrorCodeConf/Edit'
    )
);
const RoleManage = AsyncComponent(
  () => import(/* webpackChunkName: "RoleManage" */ './views/RoleManage')
);
const ResourceManage = AsyncComponent(
  () =>
    import(/* webpackChunkName: "ResourceManage" */ './views/ResourceManage')
);
const RoleManageEdit = AsyncComponent(
  () =>
    import(/* webpackChunkName: "RoleManageEdit" */ './views/RoleManage/Edit')
);
const ResourceManageEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "ResourceManageEdit" */ './views/ResourceManage/Edit'
    )
);

const Cockpitmanagement = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "Cockpitmanagement" */ './views/CockpitManagement'
    )
);
const CockpitEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "CockpitEdit" */ './views/CockpitManagement/Edit'
    )
);
const CockpitTeamManagement = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "CockpitTeamManagement" */ './views/CockpitTeamManagement'
    )
);

const CockpitTeamEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "CockpitTeamEdit" */ './views/CockpitTeamManagement/Edit'
    )
);
const CockpitTeamMemberPermission = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "CockpitTeamMemberPermission" */ './views/CockpitTeamMemberPermission'
    )
);
const DeviceLifeCycle = AsyncComponent(
  () => import(/* webpackChunkName: "DeviceLife" */ './views/DeviceLife')
);

const RouteConfigList = AsyncComponent(
  () => import(/* webpackChunkName: "RouteConfigList" */ './views/RouteConfig')
);
const RouteConfigEditInbound = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "RouteConfigEditInbound" */ './views/RouteConfig/EditInbound'
    )
);
const RouteConfigEditOutbound = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "RouteConfigEditOutbound" */ './views/RouteConfig/EditOutbound'
    )
);

const StopPointEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "StopPointEdit" */ './views/StationManagement/components/StopConfig/Edit'
    )
);

const BlackList = AsyncComponent(
  () =>
    import(/* webpackChunkName: "ServerBlackList" */ './views/ServerBlackList')
);

const OperationTime = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "SetOperationTime" */ './views/SetOperationTime'
    )
);
const VehicleEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleEdit" */ './views/StationManagement/components/LinkedVehicle/VehicleEdit'
    )
);
const GridEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleEdit" */ './views/StationManagement/components/LinkedVehicle/VehicleEdit/components/GirdEdit'
    )
);
const BindStopsBatch = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleEdit" */ './views/StationManagement/components/LinkedVehicle/VehicleEdit/components/BindStopsForUsingVehicle'
    )
);
const XMapInfoManagement = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "XMapManagement" */ './views/XMapsManagement/index'
    )
);
const XMapVersionManagement = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "XMapManagement" */ './views/XMapsManagement/XMapVersionTable/index'
    )
);
const IndicatorConfig = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "IndicatorConfig" */ './views/IndicatorConfig/index'
    )
);
const IndicatorLayerConfig = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "IndicatorLayerConfig" */ './views/IndicatorLayerConfig/index'
    )
);
const IssuePoolConfig = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "IssuePoolConfig" */ './views/IssuePoolConfig/index'
    )
);
const RobotMap = AsyncComponent(
  () => import(/* webpackChunkName: "RobotMap" */ './views/RobotMap/index')
);
const VersionInfo = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VersionInfo" */ './views/RobotMap/VersionInfo'
    )
);
const MapInfo = AsyncComponent(
  () => import(/* webpackChunkName: "MapInfo" */ './views/RobotMap/MapInfo')
);
const TaskManageView = AsyncComponent(
  () =>
    import(/* webpackChunkName: "TaskManageView" */ './views/TaskManage/index')
);
const TaskDetailView = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "TaskDetailView" */ './views/TaskManage/taskDetail'
    )
);

const WarehouseEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "WarehouseEdit" */ './views/StationManagement/components/LinkedVehicle/WarehouseEdit'
    )
);

const ShlefTypeManage = AsyncComponent(
  () =>
    import(/* webpackChunkName: "ShlefTypeManage" */ './views/ShlefTypeManage')
);

const DeviceShelfTypeManage = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "DeviceShelfTypeManage" */ './views/DeviceShelfTypeManage'
    )
);
const ParkingRangeManage = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "ParkingRangeManage" */ './views/ParkingRangeManage'
    )
);
const VehicleOperationState = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleOperationState" */ './views/VehicleOperationState'
    )
);
const BusinessTargetConfig = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "BusinessTargetConfig" */ './views/BusinessTargetConfig'
    )
);
const SettlementStatement = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "SettlementStatement" */ './views/SettlementStatement'
    )
);
const RepairOrderDetail = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "RepairOrderDetail" */ './views/RepairOrderManagement/RepairOrderDetail'
    )
);
const VehicleDemandManage = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleDemandManage" */ './views/VehicleDemandManage'
    )
);
const VehicleDemandDetail = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleDemandDetail" */ './views/VehicleDemandManage/VehicleDemandDetail'
    )
);
const VehicleOrderManage = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleOrderManage" */ './views/VehicleOrderManage'
    )
);
const ConfigureVehicle = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "ConfigureVehicle" */ './views/VehicleOrderManage/ConfigureVehicle'
    )
);
const ShippingVehicle = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "ShippingVehicle" */ './views/VehicleOrderManage/ShippingVehicle'
    )
);
const VehicleAcceptance = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleAcceptance" */ './views/VehicleOrderManage/VehicleAcceptance'
    )
);
const VehicleOrderDetail = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleOrderDetail" */ './views/VehicleOrderManage/VehicleOrderDetail'
    )
);
const MapManage = AsyncComponent(
  () => import(/* webpackChunkName: "MapManage" */ './views/MapManage')
);

// 无人车运营业务管理-事故进群规则
const AccidentIntoGroupRule = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "AccidentIntoGroupRule" */ './views/AccidentIntoGroupRule'
    )
);

// 业务数据-接驳扫单明细
const ShuttleScanDetails = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "ShuttleScanDetails" */ './views/ShuttleScanDetails'
    )
);

// 业务数据-业务计提数据
const TransportScanProvisionDetails = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "TransportScanProvisionDetails" */ './views/TransportScanProvisionDetails'
    )
);

// 业务数据-调度明细
const VehicleDispatchDetails = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleDispatchDetails" */ './views/VehicleDispatchDetails'
    )
);

// 业务数据-车辆数据明细
const VehicleShuttleDetails = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleShuttleDetails" */ './views/VehicleShuttleDetails'
    )
);

// 业务数据-站点数据明细
const StationShuttleDetails = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "StationShuttleDetails" */ './views/StationShuttleDetails'
    )
);

// 业务数据-推荐接驳点明细
const RecommendedPoiDetails = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "RecommendedPoiDetails" */ './views/RecommendedPoiDetails'
    )
);

// 业务数据-工单数据明细
const VehicleWorkOrderDetails = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleWorkOrderDetails" */ './views/VehicleWorkOrderDetails'
    )
);

// 业务数据-短驳数据看板
const ShuttleDashboard = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "ShuttleDashboard" */ './views/ShuttleDashboard'
    )
);

const LogisticMap = AsyncComponent(
  () => import(/* webpackChunkName: "LogisticMap" */ './views/LogisticMap')
);
const RentalCarReport = AsyncComponent(
  () =>
    import(/* webpackChunkName: "RentalCarReport" */ './views/RentalCarReport')
);
const RentalCarAccident = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "RentalCarAccident" */ './views/RentalCarAccident'
    )
);
const RentalCarAbnormal = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "RentalCarAbnormal" */ './views/RentalCarAbnormal'
    )
);

// poc阶段车辆跑圈任务设置
const VehicleLapMission = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "VehicleLapMission" */ './views/VehicleLapMission'
    )
);
// 车辆生产管理-路测测评管理
const RoadTestEvaluation = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "RoadTestEvaluation" */ './views/RoadTestEvaluation'
    )
);

// ============================================
// 路测工具模块 - 路由组件懒加载
// ============================================

// 路测测试项管理
const RoadTestItem = AsyncComponent(
  () => import(/* webpackChunkName: "RoadTestItem" */ './views/RoadTestItem')
);
const RoadTestItemEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "RoadTestItemEdit" */ './views/RoadTestItem/EditPage'
    )
);

// 路测方案管理
const RoadTestPlan = AsyncComponent(
  () => import(/* webpackChunkName: "RoadTestPlan" */ './views/RoadTestPlan')
);
const RoadTestPlanEdit = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "RoadTestPlanEdit" */ './views/RoadTestPlan/EditPage'
    )
);

// 缺陷提报配置
const DefectReportConfig = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "DefectReportConfig" */ './views/DefectReportConfig'
    )
);

const BugConfig = AsyncComponent(
  () => import(/* webpackChunkName: "BugConfig" */ './views/BugConfig')
);

const AbnormalDuration = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "AbnormalDuration" */ './views/AbnormalDuration'
    )
);
const AbnormalDurationAdd = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "AbnormalDurationAdd" */ './views/AbnormalDuration/add'
    )
);

// 无人车运营业务管理-分拣传站规则配置
const SortingTransferRuleConfig = AsyncComponent(
  () =>
    import(
      /* webpackChunkName: "SortingTransferRuleConfig" */ './views/SortingTransferRuleConfig'
    )
);

const baseRoutes: any[] = [
  {
    path: '/',
    element: <SimpleLayout />,
    children: [
      { index: true, element: <Navigate to="login" /> },
      { path: 'login', element: <Login /> },
    ],
  },
  {
    path: '/app',
    element: <MainLayout />,
    children: [
      {
        path: 'settlementStatement',
        children: [{ index: true, element: <SettlementStatement /> }],
      },
      // 业务数据-短驳数据看板
      {
        path: 'shuttleDashboard',
        children: [{ index: true, element: <ShuttleDashboard /> }],
      },
      // 业务数据-接驳扫单明细
      {
        path: 'shuttleScanDetails',
        children: [
          {
            index: true,
            element: <ShuttleScanDetails />,
          },
        ],
      },
      // 业务数据-业务计提数据
      {
        path: 'transportScanProvisionDetails',
        children: [
          {
            index: true,
            element: <TransportScanProvisionDetails />,
          },
        ],
      },
      // 业务数据-调度明细
      {
        path: 'vehicleDispatchDetails',
        children: [
          {
            index: true,
            element: <VehicleDispatchDetails />,
          },
        ],
      },
      // 业务数据-车辆数据明细
      {
        path: 'vehicleShuttleDetails',
        children: [
          {
            index: true,
            element: <VehicleShuttleDetails />,
          },
        ],
      },
      // 业务数据-站点数据明细
      {
        path: 'stationShuttleDetails',
        children: [
          {
            index: true,
            element: <StationShuttleDetails />,
          },
        ],
      },
      // 业务数据-推荐接驳点明细
      {
        path: 'recommendedPoiDetails',
        children: [
          {
            index: true,
            element: <RecommendedPoiDetails />,
          },
        ],
      },
      // 业务数据-工单数据明细
      {
        path: 'vehicleWorkOrderDetails',
        children: [
          {
            index: true,
            element: <VehicleWorkOrderDetails />,
          },
        ],
      },
      {
        path: 'maintainAbnormalDuration',
        children: [
          { index: true, element: <AbnormalDuration /> },
          { path: 'add', element: <AbnormalDurationAdd /> },
        ],
      },
      {
        path: 'robotMapManage',
        children: [
          { index: true, element: <RobotMap /> },
          {
            path: 'versionInfo',
            children: [
              { index: true, element: <VersionInfo /> },
              { path: 'mapInfo', element: <MapInfo /> },
            ],
          },
        ],
      },
      {
        path: 'taskManage',
        children: [
          { index: true, element: <TaskManageView /> },
          { path: 'detail', element: <TaskDetailView /> },
        ],
      },
      {
        path: 'roleManage',
        children: [
          { index: true, element: <RoleManage /> },
          { path: 'edit', element: <RoleManageEdit /> },
        ],
      },
      {
        path: 'resourceManage',
        children: [
          { index: true, element: <ResourceManage /> },
          { path: 'edit', element: <ResourceManageEdit /> },
        ],
      },
      {
        path: 'errorCodeConf',
        children: [
          { index: true, element: <ErrorCodeConf /> },
          { path: 'edit', element: <ErrorCodeConfEdit /> },
        ],
      },
      {
        path: 'vehicleInstruction',
        children: [
          { index: true, element: <VehicleInstruction /> },
          { path: 'edit', element: <VehicleInstructionEdit /> },
        ],
      },
      {
        path: 'abnormalStart',
        children: [
          { index: true, element: <AbnormalStart /> },
          { path: 'edit', element: <AbnormalStartEdit /> },
        ],
      },
      {
        path: 'hardwareSerial',
        children: [{ index: true, element: <HardwareSerial /> }],
      },
      {
        path: 'appOperation',
        children: [{ index: true, element: <AppOperation /> }],
      },
      {
        path: 'mrManage',
        children: [
          { index: true, element: <MrManage /> },
          { path: 'edit', element: <MrEdit /> },
        ],
      },
      {
        path: 'issueCateGoryManage',
        children: [
          { index: true, element: <IssueCategoryManage /> },
          { path: 'edit', element: <IssueCategoryEdit /> },
        ],
      },
      {
        path: 'issueLabelManage',
        children: [
          { index: true, element: <IssueLabelManage /> },
          { path: 'edit', element: <IssueLabelEdit /> },
        ],
      },
      {
        path: 'testing',
        children: [
          { index: true, element: <TestingManage /> },
          { path: 'edit', element: <TestingEdit /> },
        ],
      },
      {
        path: 'gridManage',
        children: [
          { index: true, element: <GridManage /> },
          { path: 'edit', element: <GridManageEdit /> },
        ],
      },
      {
        path: 'hardwareModel',
        children: [
          { index: true, element: <HardwareModel /> },
          { path: 'edit', element: <HardwareModelEdit /> },
        ],
      },
      {
        path: 'sensorSolution',
        children: [
          { index: true, element: <SensorSolution /> },
          { path: 'edit', element: <SensorSolutionEdit /> },
        ],
      },
      {
        path: 'hardwareType',
        children: [
          { index: true, element: <HardwareType /> },
          { path: 'edit', element: <HardwareTypeEdit /> },
        ],
      },
      {
        path: 'factoryManage',
        children: [
          { index: true, element: <FactoryManage /> },
          { path: 'edit', element: <FactoryManageEdit /> },
        ],
      },
      {
        path: 'repairOrderManagement',
        children: [
          { index: true, element: <RepairOrderManagement /> },
          { path: 'repairOrderDetail', element: <RepairOrderDetail /> },
        ],
      },
      {
        path: 'deviceInfo',
        children: [
          { index: true, element: <DeviceInfo /> },
          { path: 'edit', element: <DeviceInfoEdit /> },
        ],
      },
      {
        path: 'vehicleType',
        children: [
          { index: true, element: <VehicleType /> },
          { path: 'edit', element: <VehicleTypeEdit /> },
        ],
      },
      {
        path: 'stationManagement',
        children: [
          {
            index: true,
            element: <StationManagement />,
          },
          {
            path: 'addStation',
            element: <AddStation />,
          },
          {
            path: 'detail',
            children: [
              { index: true, element: <StationDetail /> },
              {
                path: 'bindStopPointBacth',
                element: <BindStopsBatch />,
              },
              {
                path: 'vehicleEdit',
                element: <VehicleEdit />,
              },
              {
                path: 'gridEdit',
                element: <GridEdit />,
              },
              {
                path: 'addStopPoint',
                element: <StopPointEdit />,
              },
              {
                path: 'editStopPoint',
                element: <StopPointEdit />,
              },
              {
                path: 'warahouseedit',
                element: <WarehouseEdit />,
              },
            ],
          },
        ],
      },
      {
        path: 'commoniframe',
        children: [{ index: true, element: <CommonIframePage /> }],
      },
      {
        path: 'cockpitmanagement',
        children: [
          { index: true, element: <Cockpitmanagement /> },
          { path: 'add', element: <CockpitEdit /> },
          { path: 'edit/:cockpitNumber', element: <CockpitEdit /> },
        ],
      },
      {
        path: 'cockpitteam',
        children: [
          { index: true, element: <CockpitTeamManagement /> },
          { path: 'add', element: <CockpitTeamEdit /> },
          {
            path: 'edit/:cockpitTeamNumber/:cockpitTeamName',
            element: <CockpitTeamEdit />,
          },
          {
            path: 'member-permission',
            element: <CockpitTeamMemberPermission />,
          },
        ],
      },
      {
        path: 'deviceLife',
        children: [{ index: true, element: <DeviceLifeCycle /> }],
      },
      {
        path: 'routeConfig',
        children: [
          { index: true, element: <RouteConfigList /> },
          { path: 'editInbound', element: <RouteConfigEditInbound /> },
          { path: 'editOutbound', element: <RouteConfigEditOutbound /> },
        ],
      },
      {
        path: 'ordermanagement',
        children: [{ index: true, element: <OrderManagement /> }],
      },
      {
        path: 'blacklist',
        children: [{ index: true, element: <BlackList /> }],
      },
      {
        path: 'operationtime',
        children: [{ index: true, element: <OperationTime /> }],
      },
      {
        path: 'xMapInfoManagement',
        children: [{ index: true, element: <XMapInfoManagement /> }],
      },
      {
        path: 'xMapVersionManagement',
        children: [{ index: true, element: <XMapVersionManagement /> }],
      },
      {
        path: 'indicatorConfig',
        children: [{ index: true, element: <IndicatorConfig /> }],
      },
      {
        path: 'indicatorLayerConfig',
        children: [{ index: true, element: <IndicatorLayerConfig /> }],
      },
      {
        path: 'issuePoolConfig',
        children: [{ index: true, element: <IssuePoolConfig /> }],
      },
      {
        path: 'insuranceManage',
        children: [
          { index: true, element: <InsuranceManage /> },
          { path: 'addInsurance', element: <InsuranceManageAdd /> },
          {
            path: 'editInsurance/:insuranceId',
            element: <InsuranceManageEdit />,
          },
        ],
      },
      {
        path: 'costAllocationManage',
        children: [{ index: true, element: <CostAllocationManage /> }],
      },
      // 无人车运营业务管理-事故进群规则
      {
        path: 'accidentIntoGroupRule',
        children: [
          {
            index: true,
            element: <AccidentIntoGroupRule />,
          },
        ],
      },
      // 无人车运营业务管理-车辆运营状态管理
      {
        path: 'vehicleOperationState',
        children: [
          {
            index: true,
            element: <VehicleOperationState />,
          },
        ],
      },
      // 无人车运营业务管理-业务目标配置
      {
        path: 'businessTargetConfig',
        children: [{ index: true, element: <BusinessTargetConfig /> }],
      },
      {
        path: 'deployMap',
        children: [{ index: true, element: <LogisticMap /> }],
      },
      {
        path: 'shelfTypeManage',
        children: [{ index: true, element: <ShlefTypeManage /> }],
      },
      {
        path: 'deviceShelfTypeManage',
        children: [{ index: true, element: <DeviceShelfTypeManage /> }],
      },
      {
        path: 'stopRangeManage',
        children: [{ index: true, element: <ParkingRangeManage /> }],
      },
      {
        path: 'vehicleDemandManage',
        children: [
          { index: true, element: <VehicleDemandManage /> },
          { path: 'detail', element: <VehicleDemandDetail /> },
        ],
      },
      {
        path: 'vehicleOrderManage',
        children: [
          { index: true, element: <VehicleOrderManage /> },
          { path: 'configureVehicle', element: <ConfigureVehicle /> },
          { path: 'shippingVehicle', element: <ShippingVehicle /> },
          { path: 'vehicleAcceptance', element: <VehicleAcceptance /> },
          { path: 'vehicleOrderDetail', element: <VehicleOrderDetail /> },
        ],
      },
      {
        path: 'mapManage',
        children: [{ index: true, element: <MapManage /> }],
      },
      {
        path: 'logisticMap',
        children: [{ index: true, element: <LogisticMap /> }],
      },
      {
        path: 'rentalCarAccident',
        children: [
          {
            index: true,
            element: <RentalCarAccident />,
          },
        ],
      },
      {
        path: 'opsAbnormalManagement',
        children: [
          {
            index: true,
            element: <RentalCarAbnormal />,
          },
        ],
      },
      {
        path: 'rentalCarReportDetail',
        children: [
          {
            index: true,
            element: <RentalCarReport />,
          },
        ],
      },
      // 车辆跑圈任务设置
      {
        path: 'vehicleLapMission',
        children: [
          {
            index: true,
            element: <VehicleLapMission />,
          },
        ],
      },
      // 路测测评管理
      {
        path: 'roadTestEvaluation',
        children: [{ index: true, element: <RoadTestEvaluation /> }],
      },
      // 路测测试项管理
      {
        path: 'roadTestItem',
        children: [
          { index: true, element: <RoadTestItem /> },
          { path: 'edit', element: <RoadTestItemEdit /> },
        ],
      },
      // 路测方案管理
      {
        path: 'roadTestPlan',
        children: [
          { index: true, element: <RoadTestPlan /> },
          { path: 'edit', element: <RoadTestPlanEdit /> },
        ],
      },
      // 缺陷提报配置
      {
        path: 'defectReportConfig',
        children: [{ index: true, element: <DefectReportConfig /> }],
      },
      // 缺陷提报人映射配置
      {
        path: 'bugConfig',
        children: [{ index: true, element: <BugConfig /> }],
      },
      // 分拣传站规则配置
      {
        path: 'sortingTransferRuleConfig',
        children: [
          {
            index: true,
            element: <SortingTransferRuleConfig />,
          },
        ],
      },
    ],
  },

  { path: '/ota/*', element: <MainLayout /> },
  { path: '/ota-ui/*', element: <MainLayout /> },
  { path: '/ota_ext/*', element: <MainLayout /> },
];

export default baseRoutes;
